/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { memo } from 'react'
import StyledComponentsRegistry from '@configs/registry'
import { onDownloadApp } from '@components/MainWidget/common/helper'
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button'
import styles from './doMoreThanChallanModal.module.scss'

export interface ChallanCard {
  title: string
  description: string
  imageUrl?: string
}

export interface DoMoreThanChallansProps {
  heading: string
  subheading: string
  cards: ChallanCard[]
  buttonText: string
  onClose: () => void
  vehicleInfoData?: any
  widgetType: string
}

const DoMoreThanChallans: React.FC<DoMoreThanChallansProps> = memo(
  ({ heading, subheading, cards, buttonText, onClose, vehicleInfoData, widgetType }) => (
    <div>
      <div className={styles.overlay} onClick={onClose}>
        <div className={styles.modal}>
          <button type="button" className={styles.closeButton} onClick={onClose}>
            &times;
          </button>

          <div className={styles.headingSection}>
            <h2 className={styles.topNote}>{heading}</h2>
            <h1 className={styles.mainHeading}>{subheading}</h1>
          </div>

          <div className={styles.cardsWrapper}>
            {cards?.map((card, idx) => (
              <div className={styles.card} key={idx}>
                <div className={styles.cardText}>
                  <h3 className={styles.cardTitle}>{card.title}</h3>
                  <p className={styles.cardDescription}>{card.description}</p>
                </div>
                <div>{card.imageUrl && <img src={card.imageUrl} alt={card.title} className={styles.cardImage} />}</div>
              </div>
            ))}
          </div>
          <StyledComponentsRegistry>
            <PrimaryButton
              className={styles.ctaButton}
              onClick={() => {
                onDownloadApp({
                  regNo: vehicleInfoData?.reg_number,
                  widgetType,
                  phone: vehicleInfoData?.mobile_number,
                  vehicleData: vehicleInfoData?.vehicleInfo,
                  providerData: vehicleInfoData?.selectedProvider,
                })
              }}>
              {buttonText}
            </PrimaryButton>
          </StyledComponentsRegistry>
        </div>
      </div>
    </div>
  )
)

export default DoMoreThanChallans
